import * as React from 'react';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
const JVThemeProvider = _ref => {
  let {
    children,
    ...restProps
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(MuiThemeProvider, restProps, children));
};
export default JVThemeProvider;